const CREATE_GOALS_NUM_STEPS = 6;

export const getProgressPercent = (currentStep: number) => currentStep / CREATE_GOALS_NUM_STEPS;
